import React from 'react';
import { useSelector } from 'react-redux';
import Pagination from '../../components/shared/table/pagination/Pagination';
import { nextUsersPageAction, prevUsersPageAction, setUsersPageSizeAction } from '../../redux/actions/usersActions';

const UsersPagination = () => {
  const pageable = useSelector((state) => state.users?.pageable);
  return (
    <Pagination
      pageable={pageable}
      onNextPageClickAction={nextUsersPageAction}
      onPrevPageClickAction={prevUsersPageAction}
      onPageSizeChangeAction={setUsersPageSizeAction}
    />
  );
};

export default UsersPagination;
